<div class="bg-blue-500 flex min-h-screen items-center justify-center">
  <div class="bg-white w-full md:w-8/12 xl:w-4/12 p-6 rounded-lg shadow-md m-4">
    <img title="Pet Pets" src="/assets/logos/logo-flat.svg" alt="Pet Pets logos" class="mx-auto w-[250px] mb-8" />
    <app-login-form [(isLoading)]="isLoading" (onSubmit)="login($event)" />
    <div class="text-center">
      <a routerLink="/register" routerLinkActive="router-link-active"
        class="text-gray-400 hover:text-blue-500 hover:font-semibold">Criar uma conta</a>
    </div>
  </div>
</div>